import './sass/app.scss'
import './startup'

import Vue from 'vue'

import App from './App.vue'
import router from './router'
// import ScrollHub from './plugins/scrollHub'
import ScrollUtils from './plugins/ScrollUtils'
import { GlobalComponents } from './components'

Vue.config.productionTip = false

// Vue.use(ScrollHub)
Vue.use(ScrollUtils, { scrollEventTarget: window })
Vue.use(GlobalComponents)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
